import { STORY_BIBLE_KEYS } from "../../../../../../../../src/shared/schemas/PluginSchema";
import { useFormikContext, getIn, Field } from "formik";
import { Switch } from "src/sudokit/components/Switch";

export const StoryBibleBlockEditor = ({ optionsPath }) => {
  const { values, setFieldValue } = useFormikContext();
  const blockOptions = getIn(values, optionsPath);

  return (
    <div>
      <Field name={`${optionsPath}.disableChiclets`}>
        {({ field }) => (
          <Switch
            label="Disable Chiclets"
            checked={field.value || false}
            onCheckedChange={(checked) => {
              setFieldValue(optionsPath, { ...blockOptions, disableChiclets: checked });
            }}
          />
        )}
      </Field>

      <p>
        {STORY_BIBLE_KEYS.map((key) => (
          <span
            className="font-mono"
            key={key}
          >
            {key}
          </span>
        )).reduce((prev, curr) => [prev, ", ", curr])}
      </p>
    </div>
  );
};
